import { render } from "./BigTitle.vue?vue&type=template&id=1cae34ca&scoped=true"
import script from "./BigTitle.vue?vue&type=script&lang=js"
export * from "./BigTitle.vue?vue&type=script&lang=js"

import "./BigTitle.vue?vue&type=style&index=0&id=1cae34ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cae34ca"]])

export default __exports__